const StatusCell = ({ value }: { value: string }) => {
	return (
		<div className="badge badge-kumopack-success-50 text-kumopack-success-700 border-radius-16px transition-300">
			<img className="me-1" src="/media/icons/kumopack/check.svg" alt="Check Icon" />
			Paid
		</div>
	)
}

export default StatusCell
